import React, { useState } from "react";
import { useGetBookmakerBetsQuery } from "../services/sports/sportsApi";
import Loading from "./Loading";

// Match detail -> Bets (Match tab) -> client id pe click -> ye modal.
// market-exposure API client ke liye team-wise P&L (book) + uski bets dikhata hai.
const MatchBookModal = ({ beventId, clientId, clientLabel, onClose }) => {
  const [page, setPage] = useState(1);
  const limit = 50;

  const { data, isLoading, error } = useGetBookmakerBetsQuery(
    { eventId: beventId, clientId: clientId || undefined, page, limit },
    { skip: !beventId || !clientId }
  );

  const bets = data?.bets || [];
  const teamNames = data?.teamNames || [];
  const allBook = data?.allBook || {};
  const myBook = data?.myBook || {};
  const pagination = data?.pagination || {};
  const totalPages = pagination.totalPages || 0;

  const bookVal = (team) => {
    const v = (allBook[team] != null ? allBook[team] : myBook[team]) || 0;
    return Number(v) || 0;
  };

  const typeLabel = (t) => {
    const lo = String(t || "").toLowerCase();
    if (lo === "back" || lo === "lagai" || lo === "yes") return "Lagai";
    if (lo === "lay" || lo === "khai" || lo === "khayi" || lo === "no") return "Khai";
    return t || "-";
  };
  const isBack = (t) => ["back", "lagai", "yes"].includes(String(t || "").toLowerCase());

  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center bg-black/60 p-3 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-2xl rounded-lg shadow-2xl my-6 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title bar */}
        <div className="bg-[#0F2327] px-4 py-3 flex items-center justify-between">
          <span className="text-white font-semibold text-sm sm:text-base">
            {(clientLabel || clientId)} Match Book
          </span>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white text-xl leading-none px-1"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="p-3 sm:p-4">
          {isLoading ? (
            <div className="flex justify-center items-center py-12"><Loading /></div>
          ) : error ? (
            <div className="p-4 text-red-500 text-center text-sm">
              {error?.data?.message || error?.message || "Failed to load match book"}
            </div>
          ) : (
            <>
              {/* P&L (team-wise book) */}
              <table className="w-full text-sm border-collapse mb-4">
                <thead>
                  <tr className="bg-[#0F2327] text-white">
                    <th className="p-2.5 border border-gray-600 text-left font-semibold">Team</th>
                    <th className="p-2.5 border border-gray-600 text-left font-semibold">P&amp;L</th>
                  </tr>
                </thead>
                <tbody>
                  {teamNames.length === 0 ? (
                    <tr><td colSpan="2" className="p-3 text-center text-gray-400 border border-gray-200">No data</td></tr>
                  ) : (
                    teamNames.map((team, i) => {
                      const v = bookVal(team);
                      return (
                        <tr key={team} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                          <td className="p-2.5 border border-gray-200 text-gray-700">{team}</td>
                          <td className={`p-2.5 border border-gray-200 font-semibold ${v >= 0 ? "text-green-600" : "text-red-600"}`}>
                            {v.toFixed(2)}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>

              {/* Bets */}
              <div className="overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-[#0F2327] text-white">
                      <th className="p-2.5 border border-gray-600 text-left font-semibold">Rate</th>
                      <th className="p-2.5 border border-gray-600 text-left font-semibold">Amount</th>
                      <th className="p-2.5 border border-gray-600 text-left font-semibold">Type</th>
                      <th className="p-2.5 border border-gray-600 text-left font-semibold">Team</th>
                      <th className="p-2.5 border border-gray-600 text-left font-semibold">Client</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bets.length === 0 ? (
                      <tr><td colSpan="5" className="p-6 text-center text-gray-400 border border-gray-200">No bets</td></tr>
                    ) : (
                      bets.map((bet, i) => (
                        <tr key={bet.betId || i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                          <td className="p-2.5 border border-gray-200 text-gray-700">{bet.rate ?? "-"}</td>
                          <td className="p-2.5 border border-gray-200 text-gray-800 font-medium">
                            {Number(bet.amount || 0).toFixed(2)}
                          </td>
                          <td className="p-2.5 border border-gray-200">
                            <span className={`inline-flex px-2 py-0.5 rounded text-[11px] font-bold ${isBack(bet.betType || bet.type) ? "bg-blue-100 text-blue-700" : "bg-pink-100 text-pink-700"}`}>
                              {typeLabel(bet.betType || bet.type)}
                            </span>
                          </td>
                          <td className="p-2.5 border border-gray-200 text-gray-700 whitespace-nowrap">{bet.runner || bet.team || "-"}</td>
                          <td className="p-2.5 border border-gray-200 text-gray-700 whitespace-nowrap">
                            {bet.userId || bet.client || clientId}
                            {bet.fullName && <span className="text-gray-400"> {bet.fullName}</span>}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex items-center justify-between mt-3">
                  <span className="text-xs text-gray-500">Page {pagination.page || page} of {totalPages}</span>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setPage((p) => Math.max(1, p - 1))}
                      disabled={(pagination.page || page) <= 1}
                      className="px-3 py-1 text-xs font-semibold rounded bg-[#0F2327] text-white disabled:opacity-40"
                    >
                      Prev
                    </button>
                    <button
                      onClick={() => setPage((p) => p + 1)}
                      disabled={(pagination.page || page) >= totalPages}
                      className="px-3 py-1 text-xs font-semibold rounded bg-[#0F2327] text-white disabled:opacity-40"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MatchBookModal;
